import { previewDetailsV2 } from "@/api/configPage";
import { PageDataConfig } from "@/types/config-page";
import { useQuery } from "@tanstack/react-query";

const useFetchConfigPage = ({
  pageCode,
  versionCode,
  previewType,
  shareUid,
  enabled = true,
}: {
  pageCode?: string;
  versionCode?: string;
  previewType?: string;
  shareUid?: string;
  enabled?: boolean;
}) => {
  const query = useQuery<PageDataConfig>({
    queryKey: ["/web-h5/charge/marketingH5Page/findPageConfig", pageCode],
    queryFn: async () => {
      const res = await previewDetailsV2({
        pageCode,
        versionCode,
        previewType,
        shareUid,
      });
      if (res.code !== 200) {
        return null;
      }
      return res.data || null;
    },
    refetchOnMount: false,
    enabled,
  });

  return query;
};

export default useFetchConfigPage;
